<template>
  <div class="mail_export_container">
    <BaseTitle
      class="d-block mb-6"
      v-text="$t('organization_mail_export.title')"
    />
    <div class="actions">
      <BaseButton
        icon="$mdiDownload"
        type="primary"
        :loading="month == 1"
        @click.stop="exportMail(1)"
      >
        {{ $t("organization_mail_export.last_1_month") }}
      </BaseButton>
      <BaseButton
        icon="$mdiDownload"
        type="primary"
        :loading="month == 3"
        @click.stop="exportMail(3)"
      >
        {{ $t("organization_mail_export.last_3_months") }}
      </BaseButton>
      <BaseButton
        icon="$mdiDownload"
        type="primary"
        :loading="month == 6"
        @click.stop="exportMail(6)"
      >
        {{ $t("organization_mail_export.last_6_months") }}
      </BaseButton>
    </div>
  </div>
</template>
<script>
import { saveAs } from "file-saver";
import Oauth from "@/core/Models/Oauth";
export default {
  name: "OrganizationMailExport",
  data() {
    return {
      month: null,
    };
  },
  methods: {
    async exportMail(month) {
      this.month = month;
      try {
        const today = new Date();
        const start_date = new Date(today);
        start_date.setMonth(today.getMonth() - month);
        const payload = new FormData();
        payload.append("start_date", this.formatDate(start_date));
        const oauth = Oauth.localStorage;
        const myHeaders = new Headers({
          Authorization: `Bearer ${oauth.accessToken}`,
        });
        const myInit = {
          method: "POST",
          headers: myHeaders,
          body: payload,
        };
        const response = await fetch(
          `/api/web/organization/${this.$route.params.organizationId}/export-emails/`,
          myInit
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        saveAs(await response.blob(), "emails.csv");
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.month = null;
    },
    formatDate(date) {
      return date.toISOString().split("T")[0];
    },
  },
};
</script>
<style lang="scss" scoped>
.mail_export_container {
  margin-top: 24px;
  padding: 24px;
  background: #fff;
  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
}
</style>
